var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item',{attrs:{"index":_vm.menu.fullPath || `${_vm.basePath}/${_vm.menu.path}`}},[(_vm.menu.icon)?_c('i',{class:_vm.menu.icon}):_vm._e(),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.menu.title || _vm.menu.meta.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }